import { FC } from 'react'

import styled from 'styled-components'

import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { PrimaryAlert } from 'src/Components/PrimaryAlert'

const StyledPrimaryDottedButton = styled(PrimaryDottedButton)`
  padding-left: 0;
  padding-right: 0;
  color: ${({ theme }) => theme.color.mediumOrange} !important;

  div {
    border-bottom-color: ${({ theme }) => theme.color.mediumOrange};
  }
`

const AlertList = styled.ul`
  padding-inline-start: 20px;
  margin-bottom: 16px;
`

interface LowReachCuratorsErrorProps {
  onContactSupportClick: () => void
}

export const LowReachCuratorsError: FC<LowReachCuratorsErrorProps> = ({
  onContactSupportClick,
}) => (
  <PrimaryAlert
    type='warning'
    hasCross={false}
    title='Almost there! Just a few more curators needed'
    renderButtons={() => (
      <StyledPrimaryDottedButton onClick={onContactSupportClick}>
        Contact support
      </StyledPrimaryDottedButton>
    )}
  >
    <div>
      Your track needs a few more curators before the campaign can start. Try
      these quick fixes:
    </div>
    <AlertList>
      <li>
        Pick genres with more available curators, which are shown in brackets
        next to each genre.
      </li>
      <li>Choose "Match selected and other languages" for a wider reach.</li>
    </AlertList>
    <div>
      Need help adjusting your campaign? Our support team is here to assist!
    </div>
  </PrimaryAlert>
)
